import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./singleProduct.layout.sass";
import HeaderPage from "../../assets/image/SingleProductHeader.png";
import SubHeaderComponent from "../../components/subHeader/subHeader.component";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
	selectProducts,
	selectSelectedProduct,
} from "../../redux/site/site.selector";
import { Col, Row } from "rsuite";
import LazyImage from "react-lazy-progressive-image";
import { SRLWrapper } from "simple-react-lightbox";
import OtherProductSliderComponent from "../../components/otherProductSlider/otherProductSlider.component";
import AddToCartComponent from "../../components/addToCart/addToCart.component";
import AdvantageComponent from "../../components/advantage/advantage.component";
import SpecificationsComponent from "../../components/specifications/specifications.component";
import { Setting } from "../../setting";

class SingleProductLayout extends React.Component {
	componentDidMount() {
		const { Product } = this.props;
		document.getElementById("productDescription").innerHTML =
			Product.description;
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		const { Product } = this.props;
		document.getElementById("productDescription").innerHTML =
			Product.description;
	}

	render() {
		const { Product } = this.props;
		console.log(Product);
		return (
			<div>
				{Product ? (
					<div>
						<SubHeaderComponent
							imageSrc={HeaderPage}
							pageName={Product.name}
							isSingleProduct
						/>
						<div className="product-layout">
							<div className="product-picture">
								<Row>
									<Col
										md={3}
										sm={8}
										xsHidden
										className="disable-touch"
									>
										<SRLWrapper>
											{Product.galery.map((item, i) => (
												<a
													key={i}
													href={`${Setting.apiUrl}${item.path}`}
												>
													<LazyImage src={`${Setting.apiUrl}${item.path}`}>
														{(src) => (
															<img
																src={src}
																alt="xitonix product"
																className="slider-picture"
															/>
														)}
													</LazyImage>
												</a>
											))}
										</SRLWrapper>
									</Col>
									<Col
										md={9}
										sm={16}
									>
										<div className="product-big-pic">
											<a
												href={Product.link}
												target="_blank"
												className="product-big-pic-link"
											>
												<img
													src={`${Setting.apiUrl}${Product.cover}`}
													alt="xitonix product"
												/>
											</a>
										</div>
									</Col>
									<Col
										mdHidden
										lgHidden
										smHidden
										xs={24}
										style={{ zIndex: "1", textAlign: "center" }}
									>
										<div className="horizontal-slider">
											<SRLWrapper>
												{Product.galery.map((item, i) => (
													<a
														key={i}
														href={`${Setting.apiUrl}${item.path}`}
													>
														<LazyImage src={`${Setting.apiUrl}${item.path}`}>
															{(src) => (
																<img
																	src={src}
																	alt="xitonix product"
																	className="responsive-slider"
																/>
															)}
														</LazyImage>
													</a>
												))}
											</SRLWrapper>
										</div>
									</Col>
									<Col
										md={12}
										sm={24}
									>
										<div className="product-description">
											<ul>
												<li>
													<span>{Product.name}</span>
												</li>
											</ul>
											<div id="productDescription" />
										</div>
									</Col>
								</Row>
							</div>
							<div className="product-info">
								<Row>
									<Col
										sm={16}
										xs={24}
									>
										<SpecificationsComponent />
									</Col>
									<Col
										sm={8}
										xs={24}
									>
										<div>
											<AddToCartComponent />
											<AdvantageComponent />
										</div>
									</Col>
								</Row>
							</div>
							<OtherProductSliderComponent />
						</div>
					</div>
				) : null}
			</div>
		);
	}
}

const mapStateToProps = createStructuredSelector({
	Product: selectSelectedProduct,
	getProducts: selectProducts,
});

export default connect(mapStateToProps)(SingleProductLayout);
